/* eslint-disable react-hooks/exhaustive-deps */
import { CloseOutlined } from '@ant-design/icons';
import { Fragment, useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Drawer } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import IconBack from '../../../assets/Images/icons/icon-back';
import Header from './Header.js';
import TaskDetail from './TaskDetail.js';
import ActivityList from './ActivityList.js';
import DsInformation from './DSInfomation.js';
import HistoryDrawer from '../MyTaskHistory/HistoryDrawer';
import PreviewTemplate from './PreviewTemplate';
import DCDPOService from '../../../services/DCDPO.service';
import MyTaskService from '../../../services/MyTask.service';
import { ROUTER } from '../../../constants/router';
import UserManagementService from '../../../services/UserManagement.service';
import UserService from '../../../services/UserService';

const STATUS_MY_TASK = {
    NEW: '56b6541a495b11ed867dfa163e89e3c8',
    VERIFIED: '5f486ec1495b11ed867dfa163e89e3c8',
    PREPARING: '63ba7d66495b11ed867dfa163e89e3c8',
    IN_PROGRESS: '66d85e5e495b11ed867dfa163e89e3c8',
    DONE: '6a1166ff495b11ed867dfa163e89e3c8',
    REJECT: '6f17a0f1495b11ed867dfa163e89e3c8',
    ARCHIVED: '8f17a0f1495b11ed867dfa163e89e3c8',
};

export default function MyTaskDetail() {
    const { t, i18n } = useTranslation();
    let lang = i18n.language;
    let navigate = useNavigate();
    let { tab, dsrTaskId } = useParams();

    // IsAccept > Confirm mode
    const [isAccept, setIsAccept] = useState(); //mockData?.isAccept
    // Change Confirm mode > Preview Email
    const [confirmMode, setConfirmMode] = useState(false);
    // Check Action Mode Mode
    // Comfirm,Extend,Cancel,Complete,Reassigned,Acknowledge
    const [actionMode, setActionMode] = useState('');
    // Check Last
    const [isCompleteLast, setIsCompleteLast] = useState(true);
    // DCDPO
    const [contact, setContact] = useState([]);
    // Set Note
    const [notes, setNotes] = useState();
    // set Selected Values
    const [selectedValues, setSelectedValues] = useState([]);
    const [requestStatus, setRequestStatus] = useState('');

    //reassignDetail
    const [cancelDetail, setCancelDetail] = useState();
    const [remindDetail, setRemindDetail] = useState([]);

    // Operation List For Flow Complete
    const [operationList, setOperationList] = useState([]);
    const [operationCancelList, setOperationCancelList] = useState([]);
    const [emailList, setEmailList] = useState([]);
    const [emailAssigneesTo, setEmailAssigneesTo] = useState([]);
    const [emailAssigneesCC, setEmailAssigneesCC] = useState([]);

    const [taskDetail, setTaskDetail] = useState();
    const [dsInformation, setDsInformation] = useState();

    // Verification
    // Assign Task
    // Complete Task
    // Other Task
    // Cancel Task
    const [state, setState] = useState('');
    const [values, setValues] = useState();
    const [userApprover, setUserApprover] = useState();

    const getUserDetail = async (userId) => {
        try {
            const { data } = await UserManagementService.getUserDetail(userId);
            const item = data?.resultData;
            if (item) {
                setUserApprover({
                    approverName: `${item?.fname} ${item?.lname}`,
                    departmentName: item?.departmentEn,
                });
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        const getDCDPO = async () => {
            try {
                const { data } = await DCDPOService.getDCDPO();
                if (data?.resultData) {
                    setContact(data?.resultData);
                }
            } catch (error) {
                console.log(error);
            }
        };
        getDCDPO();
    }, []);

    const getDSInformation = async (id) => {
        try {
            const { data } = await MyTaskService.getDSInformation(id);
            if (data?.resultData) {
                const item = data?.resultData;
                // console.log(item)
                setDsInformation(item);
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        getDSInformation(dsrTaskId);
    }, []);

    const getMyTaskDetail = useCallback(async () => {
        try {
            const { data } = await MyTaskService.getMyTaskDetail(dsrTaskId);
            if (data?.resultData) {
                if (
                    tab !== 'request-done' &&
                    data?.resultData?.status === STATUS_MY_TASK.DONE
                ) {
                    navigate(
                        `${ROUTER.DS_360.MY_TASK}/request-done/${dsrTaskId}`
                    );
                }

                const items = data?.resultData;
                setTaskDetail(items);
                setIsAccept(items?.isAccept);
                setState(items?.workflowStepStateNameEn);
                setRequestStatus(items?.statusNameEn);
            }
        } catch (error) {
            console.log(error);
        }
    }, [dsrTaskId, tab]);

    useEffect(() => {
        getMyTaskDetail();
    }, [confirmMode]);

    useEffect(() => {
        const getOperation = async () => {
            try {
                const { data } = await MyTaskService.getOperation(dsrTaskId);
                if (data?.resultData) {
                    setOperationList(data?.resultData);
                    setIsCompleteLast(data?.resultData?.isCompleteLast);
                    setEmailList(data?.resultData?.emailAssignor);
                }
            } catch (err) {
                console.log(err);
            }
        };
        if (actionMode === 'Complete') {
            getOperation();
        }

        const getPreviewOperations = async () => {
            const params = {
                previewAction: 'Task Canceling',
                dsrTaskId: dsrTaskId,
            };
            try {
                const { data } = await MyTaskService.getPreviewOperation(
                    params
                );
                if (data?.resultData) {
                    setOperationCancelList(
                        data?.resultData?.operationTasks || []
                    );
                    setEmailList(data?.resultData?.emailAssigneesTo || []);
                }
            } catch (err) {
                console.log(err);
            }
        };
        if (
            actionMode === 'Cancel' ||
            (actionMode === 'Remind' &&
                remindDetail?.statusNameEn === 'Task Canceling')
        ) {
            getPreviewOperations();
        }
        const getPreviewReassign = async () => {
            const params = {
                previewAction: 'Task Reassigned',
                operationTaskId: cancelDetail?.operationTaskId,
            };
            try {
                const { data } = await MyTaskService.getPreviewOperation(
                    params
                );
                if (data?.resultData) {
                    setOperationList(data?.resultData?.operationTasks || []);
                    setEmailAssigneesTo(
                        data?.resultData?.emailAssigneesTo || []
                    );
                    setEmailAssigneesCC(
                        data?.resultData?.emailAssigneesCC || []
                    );
                }
            } catch (err) {
                console.log(err);
            }
        };
        if (actionMode === 'Reassigned') {
            getPreviewReassign();
            getUserDetail(UserService.getUi());
        }
        if (actionMode === 'Acknowledge') {
            getUserDetail(UserService.getUi());
        }
    }, [actionMode, remindDetail, UserService.getUi()]);

    // History
    const [visibleHistories, setVisibleHistories] = useState(false);
    const [isChangeStatus, setIsChangeStatus] = useState(true);

    return (
        <>
            {!confirmMode ? (
                <Fragment>
                    <div className="title flex">
                        <button
                            className="cursor-pointer mr-3"
                            onClick={() => {
                                navigate(ROUTER.DS_360.MY_TASK);
                            }}
                        >
                            <IconBack />
                        </button>
                        {tab !== 'operation-done' &&
                            tab !== 'request-done' &&
                            tab !== 'cancel-task' &&
                            (lang === 'en'
                                ? taskDetail?.workflowStepStateNameEn ===
                                  'Assign Task'
                                    ? 'Assignment Details'
                                    : taskDetail?.workflowStepStateNameEn ===
                                      'Complete Task'
                                    ? 'Complete Details'
                                    : 'Assignment Details'
                                : taskDetail?.workflowStepStateNameEn ===
                                  'Assign Task'
                                ? 'Assignment Details'
                                : taskDetail?.workflowStepStateNameEn ===
                                  'Complete Task'
                                ? 'Complete Details'
                                : `${taskDetail?.workflowStepStateNameTh} Details`)}

                        {tab === 'operation-done' &&
                            (lang === 'en'
                                ? 'Operation Done Details'
                                : 'Operation Done Details')}
                        {tab === 'request-done' &&
                            (lang === 'en'
                                ? 'Request Done Details'
                                : 'Request Done Details')}
                        {tab === 'cancel-task' &&
                            (lang === 'en'
                                ? 'Cancel Task Details'
                                : 'Cancel Task Details')}
                    </div>
                    <div className="sub-title">
                        <span className="text-sm text-gray-400">
                            {t('Data Subject 360')} / {t('My Task')} /{' '}
                        </span>
                        <span>
                            {tab !== 'operation-done' &&
                                tab !== 'request-done' &&
                                tab !== 'cancel-task' &&
                                (lang === 'en'
                                    ? taskDetail?.workflowStepStateNameEn ===
                                      'Assign Task'
                                        ? 'Assignment Details'
                                        : taskDetail?.workflowStepStateNameEn ===
                                          'Complete Task'
                                        ? 'Complete Details'
                                        : 'Assignment Details'
                                    : taskDetail?.workflowStepStateNameEn ===
                                      'Assign Task'
                                    ? 'Assignment Details'
                                    : taskDetail?.workflowStepStateNameEn ===
                                      'Complete Task'
                                    ? 'Complete Details'
                                    : `${taskDetail?.workflowStepStateNameTh} Details`)}

                            {tab === 'operation-done' &&
                                (lang === 'en'
                                    ? 'Operation Done Details'
                                    : 'Operation Done Details')}
                            {tab === 'request-done' &&
                                (lang === 'en'
                                    ? 'Request Done Details'
                                    : 'Request Done Details')}
                            {tab === 'cancel-task' &&
                                (lang === 'en'
                                    ? 'Cancel Task Details'
                                    : 'Cancel Task Details')}
                        </span>
                    </div>
                    <div className="grid grid-cols-3 gap-4">
                        <div className="col-span-1">
                            <Header
                                detail={taskDetail}
                                setConfirmMode={setConfirmMode}
                                setActionMode={setActionMode}
                                state={state}
                                requestStatus={requestStatus}
                            />
                            <DsInformation
                                newStatus={taskDetail?.statusNameEn === 'New'}
                                data={dsInformation}
                                domainId={dsInformation?.domainId}
                                getDSInformation={() =>
                                    getDSInformation(dsrTaskId)
                                }
                            />
                        </div>
                        <div className="col-span-2">
                            <TaskDetail
                                setVisibleHistories={setVisibleHistories}
                                setIsChangeStatus={setIsChangeStatus}
                                detail={taskDetail}
                                setConfirmMode={setConfirmMode}
                                setValues={setValues}
                                setActionMode={setActionMode}
                                isAccept={isAccept}
                                setIsAccept={setIsAccept}
                                state={state}
                                setNotes={setNotes}
                                setSelectedValues={setSelectedValues}
                                selectedValues={selectedValues}
                                setCancelDetail={setCancelDetail}
                                cancelDetail={cancelDetail}
                                getMyTaskDetail={getMyTaskDetail}
                                setRemindDetail={setRemindDetail}
                                userApprover={userApprover}
                            />
                            <ActivityList />
                        </div>
                    </div>
                    <Drawer
                        width={450}
                        title={
                            <div className="flex justify-between items-center">
                                <span className="text-purple text-[17px]">
                                    {t('History')}
                                </span>
                                <button
                                    onClick={(e) => setVisibleHistories(false)}
                                    className="bg-[#F3F6F9] h-8 w-8 flex items-center justify-center rounded-lg text-purple text-sm font-semibold"
                                >
                                    <CloseOutlined />
                                </button>
                            </div>
                        }
                        placement="right"
                        onClose={() => setVisibleHistories(false)}
                        closable={false}
                        open={visibleHistories}
                        className="history"
                    >
                        <HistoryDrawer
                            setIsChangeStatus={setIsChangeStatus}
                            isChangeStatus={isChangeStatus}
                            stateName={taskDetail?.workflowStepStateNameEn}
                        />
                    </Drawer>
                </Fragment>
            ) : (
                <PreviewTemplate
                    values={values}
                    detail={taskDetail}
                    setConfirmMode={setConfirmMode}
                    workflowState={state}
                    isCompleteLast={isCompleteLast}
                    setActionMode={setActionMode}
                    actionMode={actionMode}
                    setIsAccept={setIsAccept}
                    contact={contact}
                    notes={notes}
                    dsFormData={dsInformation}
                    departmentSelected={selectedValues}
                    cancelDetail={cancelDetail}
                    operationList={operationList}
                    remindDetail={remindDetail}
                    getMyTaskDetail={getMyTaskDetail}
                    setEmailList={setEmailList}
                    emailList={emailList}
                    setOperationList={setOperationList}
                    setOperationCancelList={setOperationCancelList}
                    operationCancelList={operationCancelList}
                    userApprover={userApprover}
                    emailAssigneesTo={emailAssigneesTo}
                    emailAssigneesCC={emailAssigneesCC}
                    setNotes={setNotes}
                />
            )}
        </>
    );
}
